/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const createEnvironmentBodyNameMax = 255;

export const CreateEnvironmentBody = zod
	.object({
		name: zod.string().min(1).max(createEnvironmentBodyNameMax).describe('Environment name'),
		type: zod.enum(['production', 'sandbox'])
	})
	.describe('Environment creation\/update request');

export type CreateEnvironmentBody = zod.input<typeof CreateEnvironmentBody>;
export type CreateEnvironmentBodyOutput = zod.output<typeof CreateEnvironmentBody>;
